var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('navbar',{on:{"change-padding":_vm.changePadding}}),_c('app-main',{staticClass:"app-main",attrs:{"padding":_vm.padding}}),(_vm.allAready)?_c(_vm.footerType,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }